import { JsonRpcProvider as u } from "@ethersproject/providers";
import { RNS as p } from "@roninnetwork/rnsjs";
import { ChainAddressType as f } from "../../temp-lib/constants/chain.js";
import { useConfigContext as N } from "../../temp-lib/contexts/config/ConfigContext.js";
import C from "../../temp-lib/hooks/generic/useChainSwitcher.js";
import { useRoninNameServiceContext as R } from "../contexts/RoninNameServiceContext.js";
import * as n from "ramda";
import { useCallback as o } from "react";
const I = () => {
  const { getChainIdByType: i } = C(), { config: t } = N(), { rns: r } = R(), s = o(async () => {
    var e;
    if (n.isNil(r.current)) {
      r.current = new p();
      const a = i(f.RONIN), d = new u((e = t == null ? void 0 : t.ronin) == null ? void 0 : e.rnsRPC);
      await r.current.setProvider(d, a);
    }
  }, [i, r]), c = o((e) => n.endsWith(".ron", e), []), m = o(
    async (e) => (await s(), n.isNotNil(r.current) ? await r.current.getAddr(e) : ""),
    [s, r]
  );
  return {
    maybeRNS: c,
    resolveName: m
  };
};
export {
  I as default
};
//# sourceMappingURL=useRoninNameService.js.map
